export enum CatalogType {
  GeneralPurpose = 'GeneralPurpose',
  Fixture = 'Fixture',
}
